/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ actor: NonNullable<unknown>, caseNumber: NonNullable<unknown> }} Notifications_Note_Added_BodyInputs */

const en_notifications_note_added_body = /** @type {(inputs: Notifications_Note_Added_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.actor} added a note to case ${i?.caseNumber}.`)
};

const pt_br2_notifications_note_added_body = /** @type {(inputs: Notifications_Note_Added_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.actor} adicionou uma nota ao caso ${i?.caseNumber}.`)
};

/**
* | output |
* | --- |
* | "{actor} added a note to case {caseNumber}." |
*
* @param {Notifications_Note_Added_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_note_added_body = /** @type {((inputs: Notifications_Note_Added_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Note_Added_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_note_added_body(inputs)
	return pt_br2_notifications_note_added_body(inputs)
});